import { type FC } from 'react';
import { Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router';
import { $authInfo, useLogout } from '~/entities/auth';
import { routes } from '~/shared/constants/routes';
import { Tab, Tabs } from './components';
import { logoutTab, mobileTabs, tabs } from './constants';

interface NavbarProps {
    onClose?: VoidFunction;
    presentation?: 'desktop' | 'mobile';
}

export const Navbar: FC<NavbarProps> = ({ onClose, presentation = 'desktop' }) => {
    const navigate = useNavigate();
    const { email } = useUnit($authInfo);
    const { mutate: logout } = useLogout();
    const mobile = presentation === 'mobile';

    const handleLogout = () => {
        logout(undefined, {
            onSuccess: () => {
                notifications.show({
                    title: 'Успешно',
                    message: 'Вы успешно вышли из аккаунта',
                    color: 'green',
                });
                navigate(routes.login);
            },
        });
    };

    return (
        <Stack
            gap={mobile ? 16 : 4}
            justify='space-between'
            h='100%'
            p={mobile ? 16 : 8}
        >
            <Stack
                gap={mobile ? 10 : 4}
                align={mobile ? 'stretch' : 'center'}
            >
                {mobile && email && (
                    <Text
                        c='dimmed'
                        size='sm'
                        px='sm'
                        truncate
                    >
                        {email}
                    </Text>
                )}

                <Tabs
                    tabs={mobile ? mobileTabs : tabs}
                    onClose={onClose}
                    compact={!mobile}
                />
            </Stack>

            <Tab
                tab={logoutTab(handleLogout)}
                onClose={onClose}
                compact={!mobile}
            />
        </Stack>
    );
};
